module.exports = __webpack_public_path__ + "img/patrulla_stj_down.dbaa3adb.svg";